<template>
  <v-container
    fluid
    class="login"
  >
    <v-flex
      xs12
      md4
      offset-md4
    >
      <v-card ref="card">
        <v-card-text style="text-align: center">
          <img src="../assets/logo_blue.png">
          <h1 class="primary--text">
            Recuperar senha
          </h1>
        </v-card-text>
        <v-card-text>
          Informe seu e-mail cadastrado e enviaremos uma nova senha
          <v-form v-model="isFormValid">
            <v-text-field
              ref="email"
              v-model="email"
              type="email"
              :rules="emailRules"
              placeholder="Digite o e-mail cadastrado"
              required
            />
          </v-form>
          <v-card-actions>
            <v-btn
              text
              :to="{name: 'Login'}"
            >
              Cancelar
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              rounded
              :disabled="!isFormValid"
              @click="submit(email)"
            >
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const login = createNamespacedHelpers('login');

export default {
  name: 'Recover',
  data: () => ({
    email: null,
    isFormValid: false,
  }),

  computed: {
    ...login.mapState([
      'overlay',
      'recEmail',
    ]),
    emailRules() {
      return [
        this.$rules.required(),
        this.$rules.email(),
      ];
    },
  },
  mounted() {
    if (this.recEmail.length) {
      this.email = this.recEmail;
    }
  },
  methods: {
    ...login.mapMutations([
      'setOverlay',
    ]),
    ...login.mapActions(['passwordReset']),
    submit(email) {
      this.setOverlay(true);
      this.passwordReset({ email });
    },
  },
};
</script>
<style lang="stylus" scoped>
.login /deep/ {
  .theme--light.v-sheet {
      border-radius: 10px;
      margin-top: 10vh;
      padding: 20px 30px 25px;
  }
  .theme--light.v-sheet h1 { font-weight: normal }
  .v-btn {
    text-transform: none;
  }
  .v-card__text input {
    padding-left: 5px;
    font-size: 14px;
  }
}
</style>
